/**
 * Entidades do protocolo — a forma exacta que atravessa a rede.
 * NÃO são os modelos do Prisma: nunca serializamos passwordHash, tokens ou
 * emails de terceiros por acidente. O mapeamento vive em apps/api/src/serializers.
 */
/**
 * Estados que um utilizador pode ESCOLHER. OFFLINE não está aqui de propósito:
 * offline é o que se é quando não há sessão, não uma escolha — quem quer
 * aparecer offline estando ligado escolhe INVISIBLE, e a diferença importa
 * porque o INVISIBLE continua a receber tudo.
 *
 * Vive aqui, no partilhado, porque a escolha entra por DOIS caminhos (o
 * `PATCH /users/@me` e o `UpdatePresence` do gateway) e só o segundo é que o
 * cliente usa de facto. Ter a lista num deles só era ter meia guarda.
 */
export const SELECTABLE_STATUSES = ["ONLINE", "IDLE", "BUSY", "INVISIBLE"];
export function isSelectableStatus(value) {
    return typeof value === "string" && SELECTABLE_STATUSES.includes(value);
}
/**
 * O estado como TERCEIROS o podem ver. Escolher "invisível" e depois anunciar
 * "estou invisível" a toda a gente é o contrário do que o botão promete: para
 * os outros tem de ser indistinguível de offline.
 *
 * Uma função e não um `=== "INVISIBLE" ? ...` copiado: a regra estava em três
 * sítios (serializador, READY, PATCH REST) e faltava no quarto — precisamente
 * naquele por onde a escolha entra.
 */
export function statusForOthers(status) {
    return (status === "INVISIBLE" ? "OFFLINE" : status);
}
//# sourceMappingURL=entities.js.map